import React from 'react'
import { useState, useEffect } from 'react'
import { BackButton } from '@/components/layout/NavBar'
import { Services } from '@/services/services'
import { useParams } from 'react-router-dom'

import { CurrentSession } from '@/services/repository/session'
import { MainPageLayout } from '@/components/layout/MainLayout'
import { Translates } from '@/services/repository/i18n'
import { HitMapComponent, MapRow } from '@/components/Map/HitMap'

import './MyHitMap.css'
import { HitMapNav, HitMapNavData, HitMapNavURLParams, hitsMap } from '../HitMap'
import { getTodayRange } from '@/common/time'

export const CommunalMyHitsMap = ({ services, session }: { services: Services, session: CurrentSession }) => {
  // const mid = useParams().mid
  const [navData, setNavData] = useState<HitMapNavData>({
    range: getTodayRange(),
    hitLvl: 'all',
    machinePoint: '',
    username: '',
    hitRange: hitsMap.all
  })
  const [rows, setRows] = useState<MapRow[] | undefined>(undefined)
  const [translates, setTranslates] = useState<Translates>()

  useEffect(() => {
    if (session) {
      setTranslates(session.translates)
      return
    }
    services.i18n.get('main').then(setTranslates)
  }, [session])

  useEffect(() => {
    services.session.fetchWithToken(`/api/communal/my/hits/all?${HitMapNavURLParams(navData)}`).then(async (r) => {
      if (r.status !== 200) {
        const erros = await r.json()
        console.error(erros)
        return Promise.reject<MapRow[]>()
      }
      const resp: MapRow[] = await r.json()
      setRows(resp)
    })
  }, [navData])

  if (translates === undefined) {
    return <div className='spinner'></div>
  }

  return <MainPageLayout pageName='my-hitmap' services={services} translates={translates} session={session}
    navbarLeft={<BackButton services={services} translates={session.translates} />}>
    
    <HitMapNav session={session} services={services} data={navData} setter={setNavData} fieldMatrix={{
      range: true,
      username: false,
      machineName: true
    }}/>

    <HitMapComponent rows={rows} services={services} session={session} />
  </MainPageLayout>
}
